export enum TasksTabs {
  OPEN = "OPEN",
  IN_PROGRESS = "IN_PROGRESS",
  UPCOMING = "UPCOMING",
  COMPLETED = "COMPLETED",
  CLOSED = "CLOSED",
}
